import { z } from "zod"
import { Element } from "../element"

// Version 1 ---------------------
export const SectionElementV1 = z.object({
  id: z.string(),
  name: z.literal("section"),
  children: z.lazy(() => z.array(Element)),
})

export type TSectionElementV1 = z.infer<typeof SectionElementV1>

// Latest ---------------------
export const SectionElement = SectionElementV1
export type TSectionElement = TSectionElementV1
